import type { SyntheticEvent } from "react";
import { useState } from "react";

import dompurify from "isomorphic-dompurify";

import { Box } from "@jti/core-components/components/Box";
import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import getCurrentDescription from "../../utils/getCurrentDescription";

import style from "./ProductDescription.module.scss";

type ProductDescriptionType = {
  description: string;
};

const { sanitize } = dompurify;

const DESCRIPTION_LIMIT = 300;

export const ProductDescription = ({ description }: ProductDescriptionType) => {
  const [showLongDescription, setShowLongDescription] = useState(false);
  const { __ } = useTranslations();

  const toggleDescription = (event: SyntheticEvent) => {
    event.preventDefault();

    setShowLongDescription(!showLongDescription);
  };

  return (
    <Box title={__("product.info.description")} data-testid="descriptionBlock">
      <div
        className="pdpDescription"
        dangerouslySetInnerHTML={{
          __html: sanitize(getCurrentDescription(description, showLongDescription, DESCRIPTION_LIMIT)),
        }}
      ></div>

      {description.length > DESCRIPTION_LIMIT && (
        <div className={style.readMore}>
          <Button onClick={toggleDescription} variant="text">
            {__(showLongDescription ? "product.info.readLess" : "product.info.readMore")}
          </Button>
        </div>
      )}
    </Box>
  );
};
